import React from "react";
import PropTypes from "prop-types";
import {AListItem, AListItemTitle} from "@cisco-sbg-ui/magna-react";
import {t} from "i18next";
import {DropdownMenu} from "components/DropdownMenu";
import MultiSelectCheckbox from "components/MultiSelectCheckbox";

const TypeSelectDropdown = ({
  types,
  selectedTypes,
  setSelectedTypes,
  disabled
}) => (
  <DropdownMenu
    buttonContent={t("investigationDetail.toolbar.typesDropdownBtn")}
    buttonVariant="select"
    buttonClass={"mr-2"}
    menuPlacement="bottom-left"
    buttonProps={{disabled, medium: true}}>
    {types.map((type, idx) => (
      <MultiSelectCheckbox
        key={`type-${idx}`}
        checkboxAsMenuItem
        value={type}
        selected={selectedTypes}
        setSelected={(selected) => setSelectedTypes(selected)}>
        <AListItemTitle>{type}</AListItemTitle>
      </MultiSelectCheckbox>
    ))}
    <AListItem onClick={() => setSelectedTypes([])}>
      {t("investigationDetail.toolbar.clearAllBtn")}
    </AListItem>
  </DropdownMenu>
);

TypeSelectDropdown.propTypes = {
  types: PropTypes.array,
  selectedTypes: PropTypes.array,
  setSelectedTypes: PropTypes.func,
  disabled: PropTypes.bool
};

export default TypeSelectDropdown;
